import React from 'react';
import NumberFormat from 'react-number-format';
import { Icon } from 'semantic-ui-react';
import { computeDeliveryCost, parseStatus } from '../../../utils/shared.utils';
import { parsePaymentChannel } from '../../../constants/payment-channel';
import { RECEIPT_BUSINESS_NAME, RECEIPT_SEAL_IMAGE_URL } from '../../../constants/receipt';
import { orderAddressText } from '../../../utils/orderDelivery';

type DeliveryReceipt2Props = {
  order: any;
};

/** Хүргэлтийн баримт (receipt-print-2) — shared by order page and batch print. */
function DeliveryReceipt2({ order }: DeliveryReceipt2Props) {
  return (
    <div className="receipt-container receipt-print-2">
      {[1, 2].map((dummy: any, dummyi: number) => {
        return <div className="receipt" key={"receipt2-" + dummyi}>
        <h2>Баримт</h2>
        <h4 style={{float: 'right', color: 'orange'}}><NumberFormat displayType="text" value={order.itemsDeliveryCost || 0} thousandSeparator={true} /></h4>
        <div>
          <div className="client-order">
            <div className="business-name">
              {RECEIPT_BUSINESS_NAME}
            </div>
            <div className="order-top">
              <div className="order-col order-id fontMain-2">
                <div className="col-top">№</div>
                <div>
                  <strong>{order?.token}</strong>
                </div>
              </div>
              <div className="order-col order-amount">
                <div className="col-top">Нийт дүн</div>
                <div>
                  <NumberFormat
                    displayType={'text'}
                    value={order?.totalAmount || 0}
                    suffix="₮"
                    thousandSeparator={true}
                  />
                </div>
              </div>
              <div className="order-col">
                <div className="col-top">Төлөв</div>
                <div className={`order-status ${String(order.status || '').toLowerCase()}`}>{parseStatus(order.status)}</div>
              </div>
            </div>

            <div className="order-items">
              {order.companyName ?
              <>
                <div className="order-contact">
                  <strong>Байгууллагын нэр: </strong>
                  {order.companyName}
                </div>
                <div className="order-contact">
                  <strong>Байгууллагын регистр: </strong>
                  {order.companyRegister}
                </div>
                <div className="order-contact">
                  <strong>Утасны дугаар: </strong>
                  {order.companyPhone}
                </div>
              </>
              :
              <>
                <div className="order-contact">
                  <strong>Нэр: </strong>
                  {order.ownName}
                </div>
                <div className="order-contact">
                  <strong>Утас: </strong>
                  {order.phone}
                </div>
              </>
              }
              <div className="order-address">
                <strong className="col-top">Хаяг: </strong>
                <span>{orderAddressText(order)}</span>
              </div>
              {order.deliveryNote ? (
                <div className="order-address">
                  <strong className="col-top">Тайлбар: </strong>
                  <span>{order.deliveryNote}</span>
                </div>
              ) : null}

              {order.deliveries?.map((delivery: any, dindex: number) => {
                return <div className="order-delivery" key={'delivery-' + delivery.id}>
                  <div className="order-delivery-top">
                    <span className="delivery-date">
                      <Icon name="calendar outline" />{delivery?.date} &nbsp;
                    </span>
                    <span className="delivery-cost"> - Хүргэлтийн үнэ: - <NumberFormat displayType="text" value={delivery?.cost} thousandSeparator={true} suffix="₮" /></span>
                  </div>
                  <table>
                    <tbody>
                      {delivery?.items?.map((item: any, index: number) => {
                        return <tr key={`order-${item.id}-${index}`}>
                          <td>{item.product.name} {item.product.size? " - " + item.product.size : ""} {item.product.size ? item.product.unit : ""}</td>
                          <td>
                            <NumberFormat displayType="text" value={item.price} suffix="₮" thousandSeparator={true} /> x {item.count}
                            &nbsp;=&nbsp;
                            <NumberFormat displayType="text" value={item.price * item.count} suffix="₮" thousandSeparator={true} />
                          </td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                </div>
              })
              }
            </div>
            <div className="order-summary">
              <div>Барааны нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount - order.totalDeliveryCost} suffix="₮" thousandSeparator={true} /></div>
              <div>Хүргэлтийн нийт үнэ: <NumberFormat displayType="text" value={order.totalDeliveryCost} suffix="₮" thousandSeparator={true} /></div>
              <div>Нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount || 0} suffix="₮" thousandSeparator={true} /></div>
              <br />
              {parsePaymentChannel(order.paymentChannel) ?
              <div>Худалдан авсан сувгийн төлөв: {parsePaymentChannel(order.paymentChannel)}</div>
              : null
              }
              {order.payLater ?
              <div>Төлбөр төлөх дансны дугаар: MN570004000438016886 (Худалдаа Хөгжлийн Банк)</div>
              : null
              }
              <hr />
              <div className="two-col">
                <div className="signs">
                  <div>Нийт хайрцаг тоо: </div>
                    <br/>
                  <div>Хүлээн авсан: </div>
                </div>
                <div className="stamp">
                  <img src={RECEIPT_SEAL_IMAGE_URL} height="70"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      })}
    </div>
  );
}

export type DeliveryReceiptSettings = {
  freeDeliveryMinAmount: number;
  deliveryPrice: number;
  deliveryBaseWeightKg: number;
  deliveryPricePerBase: number;
};

/**
 * `delivery.cost`/`order.totalDeliveryCost` as stored is the customer-facing delivery fee
 * chef-api's order.module.js computes at order time (free at/above FREE_DELIVERY_MIN, else
 * the flat DELIVERY_PRICE, or a super-user's manual override) — trusted as-is here, never
 * recomputed, so a super-user override (including a manual 0) isn't silently discarded.
 *
 * `order.itemsDeliveryCost` (shown at the top of this receipt) is a separate, internal/
 * Papa-facing figure — weight-based (DELIVERY_BASE_WEIGHT_KG/DELIVERY_PRICE_PER_BASE), same
 * formula as chef-api's getPapaCargoUserPrice. It never uses `item.deliveryCost` (the old
 * manual per-product field), which Papa pricing no longer uses either.
 */
export function prepareOrderForDeliveryReceipt(order: any, settings?: DeliveryReceiptSettings): any {
  const copy = { ...order, deliveries: (order.deliveries || []).map((d: any) => ({ ...d, items: [...(d.items || [])] })) };
  let itemsDeliveryCost = 0;
  for (const delivery of copy.deliveries) {
    const date = new Date(delivery.date);
    if (!Number.isNaN(date.getTime()) && !(typeof delivery.date === 'string' && delivery.date.includes('сарын'))) {
      delivery.date = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`;
    }
    for (const item of delivery.items || []) {
      itemsDeliveryCost += settings
        ? computeDeliveryCost(item.product, item.count, settings)
        : (Number(item.deliveryCost) || 0) * (Number(item.count) || 0);
    }
  }
  if (copy.itemsDeliveryCost == null) {
    copy.itemsDeliveryCost = itemsDeliveryCost;
  }
  return copy;
}

export default DeliveryReceipt2;
